import { createSelector } from 'reselect';
import type { AuthState } from './auth.reducer';

const selectAuth = (state: { auth: AuthState }): AuthState => state.auth;

export const selectAuthStatus = createSelector([selectAuth], (a) => a.authStatus);
export const selectAuthError = createSelector([selectAuth], (a) => a.authError);
export const selectAuthErrorCode = createSelector([selectAuth], (a) => a.authErrorCode);
export const selectRole = createSelector([selectAuth], (a) => a.role);
export const selectUserName = createSelector([selectAuth], (a) => a.userName);
export const selectAccessToken = createSelector([selectAuth], (a) => a.accessToken);
export const selectAuthUser = createSelector([selectAuth], (a) => a.user);
export const selectMustChangePassword = createSelector([selectAuth], (a) => a.mustChangePassword);
export const selectIsLoggedIn = createSelector(
  [selectAuth],
  (a) => a.role !== null && a.accessToken !== null,
);
